import React, { useState, useContext } from "react";
import api from "../../utils/Api";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom"; 
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";

function LoginForm() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (email.trim() === "") newErrors.email = "El campo email es obligatorio.";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "El email no es válido.";
    if (password.trim() === "") newErrors.password = "El campo contraseña es obligatorio.";
    else if (password.length < 6) newErrors.password = "La contraseña debe tener al menos 6 caracteres.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGeneralError("");
    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) return;

    try {
      const response = await api.post("/login", { email, password });
      const { token } = response.data;

      login(token);
      const decodedToken = jwtDecode(token);

      if (decodedToken.rol === "admin") navigate("/admin");
      else if (decodedToken.rol === "empleado") navigate("/empleados");
      else navigate("/");

      setEmail("");
      setPassword("");
      setErrors({});
    } catch (error) {
      if (error.response && error.response.data) {
        setErrors(error.response.data.errors || {});
        if (!error.response.data.errors) {
          setGeneralError(error.response.data.error || "Error al iniciar sesión. Inténtalo de nuevo.");
        }
      } else {
        setGeneralError("Error al iniciar sesión. Inténtalo de nuevo.");
      }
    }
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh", padding: "1rem", backgroundColor: "#f8f9fa" }}
    >
      {/* Logo encima */}
      <h2 className="fw-semibold mb-4 text-center" style={{ color: "#2C2C2C" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#FF7A00"
          className="bi bi-clock-history me-2 align-middle"
          viewBox="0 0 16 16"
        >
          <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
          <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
        </svg>
        Turnora
      </h2>

      {/* Tarjeta */}
      <div className="col-12 col-sm-10 col-md-6 col-lg-4 bg-white p-4 rounded shadow text-center">
        <div className="mb-4 text-center fs-4" style={{ color: "#2C2C2C" }}>
          Accede a tu cuenta
        </div>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-3 text-start">
            <label htmlFor="email" className="form-label" style={{ fontSize: "14px" }}>
              Email:
            </label>
            <input
              type="email"
              id="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ borderColor: errors.email ? "#dc3545" : "#ccc" }}
              placeholder="Email"
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>

          {/* Password */}
          <div className="mb-3 text-start">
            <label htmlFor="password" className="form-label" style={{ fontSize: "14px" }}>
              Contraseña:
            </label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ borderColor: errors.password ? "#dc3545" : "#ccc" }}
                placeholder="Contraseña"
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
              </button>
            </div>
            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
          </div>

          {/* Submit */}
          <div className="d-grid mb-3">
            <button
              type="submit"
              className="btn"
              style={{ backgroundColor: "#FF7A00", color: "#fff", border: "none" }}
            >
              Iniciar Sesión
            </button>
          </div>

          {/* Links */}
          <div className="text-center mb-2" style={{ fontSize: "14px" }}>
            <Link
              to="/reset-password"
              style={{ color: "#2C2C2C", fontWeight: "500", textDecoration: "none" }}
            >
              ¿Has olvidado tu contraseña?
            </Link>
          </div>
          <div className="text-center" style={{ fontSize: "14px" }}>
            ¿No tienes cuenta aún?{" "}
            <Link
              to="/register"
              style={{ color: "#FF7A00", fontWeight: "500", textDecoration: "none" }}
            >
              Regístrate
            </Link>
          </div>
        </form>

        {generalError && (
          <div className="mt-3 text-center">
            <div className="alert alert-danger">{generalError}</div>
          </div>
        )}
      </div>

      <div className="text-center mt-4" style={{ fontSize: "12px" }}>
        Ver la documentación completa{" "}
        <Link
          to="/docs"
          style={{ color: "#FF7A00", fontWeight: "500", textDecoration: "none" }}
        >
          aquí
        </Link>.
      </div>
    </div>
  );
}

export default LoginForm;
